<template>
    <label class="CLabel">
        <slot />
    </label>
</template>

